import React, { Component } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { deleteRecord, getExtras, createNewExtra, updateExtra } from '../utils/OpenCampground_Database_Calls';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Dialog, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { withStyles } from '@material-ui/core/styles';

const useStyles = theme => ({
    dialogPaper: {
        padding: theme.spacing(2),
        borderRadius: '10px',
    }
});

const theme = createTheme({
    palette: {
        primary: {
            main: '#2dcd7a',
        },
    },
});

class Extras extends Component {
    constructor(props) {
        super(props);
        this.state = {
            extras: [],
            extrasUpdate: false,
            formValid: false,
            extraName: '',
            remote: false,
            remoteRequired: false,
            active: true,
            extraType: 'standard',
            daily: '',
            week: '',
            month: '',
            rate: '',
            unit: '',
            charge: '',
            editingExtraId: null,
            addNew: false,
            open: false,
            popupTitle: '',
            popupText: '',
            deleteId: '',
            confirmOpen: false,
            confirmPopupTitle: 'Delete Extras',
            ConfirmPopupText: 'Please make sure that the extras that you are deleting is not associated with any of the current or future reservations.'
        };
    }

    async componentDidMount() {
        this.loadExtras();
    }

    deleteRecord = async (id) => {
        await deleteRecord(this.props.user, this.props.serverName, "extras", id);
        this.setState({
            extrasUpdate: true,
            open: true,
            popupTitle: 'Delete Extras',
            popupText: 'Extras deleted successfully.'
        });
        this.loadExtras();
    }

    loadExtras = async () => {
        if (this.state.extrasUpdate || this.state.extras.length === 0) {
            const extras = await getExtras(this.props.user, this.props.serverName);
            this.setState({ extras, extrasUpdate: false });
        }
    }

    getExtraTypeDisplay = (extraType) => {
        const typeMap = {
            0: 'Standard',
            1: 'Counted',
            2: 'Measured',
            3: 'Occasional',
            4: 'Deposit'
        };
        return typeMap[extraType] || '';
    }

    handleChange = (event) => {
        const { id, name, value, checked, type } = event.target;
        this.setState({
            [id || name]: type === 'checkbox' ? checked : value
        }, this.formValidation);
    }

    formValidation = () => {
        const { extraName, daily, week, month, rate, unit, charge } = this.state;
        if (this.state.extraType === 'standard' || this.state.extraType === 'counted') {
            const isValid = extraName && daily && week && month;
            this.setState({ formValid: isValid });
        } else if (this.state.extraType === 'metered') {
            const isValid = extraName && rate && unit;
            this.setState({ formValid: isValid });
        } else if (this.state.extraType === 'occasional' || this.state.extraType === 'deposit') {
            const isValid = extraName && charge;
            this.setState({ formValid: isValid });
        } else {
            this.setState({ formValid: false });
        }
    }

    addNew = async () => {
        await createNewExtra(this.props.user, this.props.serverName, this.state.extraName, this.state.daily, this.state.week, this.state.month, this.state.charge,
            this.state.rate, this.state.unit, this.state.extraType, this.state.remote, this.state.remoteRequired)
        this.setState({
            popupTitle: 'New Extra',
            popupText: 'New extra added successfully.',
            open: true
        })
        this.resetForm()
        this.loadExtras();
    }

    startEditing = (extra) => {
        this.setState({
            editingExtraId: extra.id,
            extraName: extra.name,
            remote: extra.remote_display,
            remoteRequired: extra.remote_required,
            extraType: this.getExtraTypeDisplay(extra.extra_type.toString()).toLowerCase(),
            daily: extra.daily,
            week: extra.weekly,
            month: extra.monthly,
            rate: extra.rate,
            unit: extra.unit,
            charge: extra.charge,
            active: extra.active
        });
    }

    saveEdits = async () => {
        let extraType
        if (this.state.extraType === 'standard') {
            extraType = 0
        } else if (this.state.extraType === 'counted') {
            extraType = 1
        } else if (this.state.extraType === 'metered') {
            extraType = 2
        } else if (this.state.extraType === 'occasional') {
            extraType = 3
        } else {
            extraType = 4
        }
        await updateExtra(this.props.user, this.props.serverName, this.state.editingExtraId, this.state.extraName, this.state.remote, this.state.remoteRequired, extraType,
            this.state.daily, this.state.week, this.state.month, this.state.rate, this.state.unit, this.state.charge, this.state.active);
        this.resetForm()
        this.setState({
            open: true,
            popupTitle: 'Edit Extras',
            popupText: 'Extras updated successfully.'
        })
        this.loadExtras();
    }

    handleExtraTypeSelect = (event) => {
        this.setState({
            extraType: event.target.value
        })
    }

    resetForm = () => {
        this.setState({
            extrasUpdate: true,
            extraName: '',
            remote: false,
            remoteRequired: false,
            active: true,
            extraType: 'standard',
            daily: '',
            week: '',
            month: '',
            rate: '',
            unit: '',
            charge: '',
            editingExtraId: null,
            addNew: false,
        })
    }

    render() {
        const { classes } = this.props;
        return (
            <ThemeProvider theme={theme}>
                <Dialog open={this.state.confirmOpen} onClick={() => this.setState({ confirmOpen: false })} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.confirmPopupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.ConfirmPopupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => this.setState({ confirmOpen: false })} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Cancel
                        </Button>
                        <Button onClick={() => this.deleteRecord(this.state.deleteId)} style={{ backgroundColor: '#2dcd7a', color: '#000000', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.open} onClose={() => { this.setState({ open: false }) }} classes={{ paper: classes.dialogPaper }}>
                    <DialogTitle>{this.state.popupTitle}</DialogTitle>
                    <DialogContent>
                        {this.state.popupText}
                    </DialogContent>
                    <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => { this.setState({ open: false }) }} style={{ backgroundColor: '#FDECEB', color: '#DB3737', padding: '2% 10% 2% 10%', margin: '0 0 0 2%', borderRadius: '10px', marginTop: '3%' }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Button
                    className='resButton'
                    onClick={() => this.setState({ addNew: true })}
                    style={{ backgroundColor: '#2dcd7a', color: '#000000', textTransform: "capitalize", marginBottom: '2%' }}
                >
                    Add New Extra
                </Button>

                {this.state.addNew || this.state.editingExtraId ? (
                    <Dialog open={this.state.addNew || this.state.editingExtraId} onClose={() => {
                        this.resetForm();
                    }} maxWidth="sm" fullWidth>
                        <DialogContent dividers>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                <h2 style={{ margin: "0px", marginBottom: "10px" }}>{this.state.editingExtraId ? "Update Extra" : "Add Extra"}</h2>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <TextField
                                        id="extraName"
                                        required
                                        label="Extra Name"
                                        value={this.state.extraName}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <FormControlLabel
                                        label={"Online Display"}
                                        control={
                                            <Checkbox
                                                id="remote"
                                                checked={this.state.remote}
                                                onChange={this.handleChange}
                                            />
                                        }
                                    />

                                    <FormControlLabel
                                        label={"Online Required"}
                                        control={
                                            <Checkbox
                                                id="remoteRequired"
                                                checked={this.state.remoteRequired}
                                                onChange={this.handleChange}
                                            />
                                        }
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    <RadioGroup
                                        value={this.state.extraType}
                                        row
                                        onChange={this.handleExtraTypeSelect}
                                    >
                                        <FormControlLabel value="standard" control={<Radio color="primary" />} label="Standard" />
                                        <FormControlLabel value="counted" control={<Radio color="primary" />} label="Counted" />
                                        <FormControlLabel value="metered" control={<Radio color="primary" />} label="Metered" />
                                        <FormControlLabel value="occasional" control={<Radio color="primary" />} label="Occasional" />
                                        <FormControlLabel value="deposit" control={<Radio color="primary" />} label="Deposit" />
                                    </RadioGroup>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                                    {this.state.extraType === 'standard' || this.state.extraType === 'counted'
                                        ?
                                        <>
                                            <TextField
                                                id="daily"
                                                required
                                                label="Daily"
                                                value={this.state.daily}
                                                onChange={this.handleChange}
                                            />
                                            <TextField
                                                id="week"
                                                required
                                                label="Weekly"
                                                value={this.state.week}
                                                onChange={this.handleChange}
                                            />
                                            <TextField
                                                id="month"
                                                required
                                                label="Monthly"
                                                value={this.state.month}
                                                onChange={this.handleChange}
                                            />
                                        </>
                                        : null}
                                    {this.state.extraType === 'metered'
                                        ?
                                        <>
                                            <TextField
                                                id="rate"
                                                required
                                                label="Rate/Unit"
                                                value={this.state.rate}
                                                onChange={this.handleChange}
                                            />
                                            <TextField
                                                id="unit"
                                                required
                                                label="Unit"
                                                value={this.state.unit}
                                                onChange={this.handleChange}
                                            />
                                        </>
                                        : null}
                                    {this.state.extraType === 'occasional' || this.state.extraType === 'deposit'
                                        ?
                                        <>
                                            <TextField
                                                id="charge"
                                                required
                                                label="Charge"
                                                value={this.state.charge}
                                                onChange={this.handleChange}
                                            />
                                        </>
                                        : null}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px' }}>
                                    <Button
                                        style={{ backgroundColor: '#2dcd7a', color: '#000000' }}
                                        onClick={() => { this.state.editingExtraId ? this.saveEdits() : this.addNew(); }}
                                        disabled={this.state.editingExtraId ? false : !this.state.formValid}
                                    >
                                        {this.state.editingExtraId ? 'Save Edits' : 'Add New'}
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: '#FDECEB', color: '#DB3737' }}
                                        onClick={() => { this.resetForm() }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>
                    </Dialog>
                ) : ""}
                <TableContainer component={Paper} style={{ width: '90%', margin: '0 auto' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className='tableCell'>Name</TableCell>
                                <TableCell className='tableCell'>Type</TableCell>
                                <TableCell className='tableCell'>Rate Per Unit</TableCell>
                                <TableCell className='tableCell'>Unit</TableCell>
                                <TableCell className='tableCell'>Charge</TableCell>
                                <TableCell className='tableCell'>Daily</TableCell>
                                <TableCell className='tableCell'>Weekly</TableCell>
                                <TableCell className='tableCell'>Monthly</TableCell>
                                <TableCell className='tableCell'>Online Display</TableCell>
                                <TableCell className='tableCell'>Online Required</TableCell>
                                <TableCell className='tableCell'>Active</TableCell>
                                <TableCell className='tableCell'>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.extras.map((extra) => (
                                <TableRow key={extra.id}>
                                    <TableCell className='tableCell'>
                                        {extra.name}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {this.getExtraTypeDisplay(extra.extra_type)}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {`$${parseFloat(extra.rate).toFixed(2)}`}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {extra.unit_name}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {`$${parseFloat(extra.charge).toFixed(2)}`}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {`$${parseFloat(extra.daily).toFixed(2)}`}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {`$${parseFloat(extra.weekly).toFixed(2)}`}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {`$${parseFloat(extra.monthly).toFixed(2)}`}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {(extra.remote_display ? 'Yes' : 'No')}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {(extra.remote_required ? 'Yes' : 'No')}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        {extra.active ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell className='tableCell'>
                                        <div>
                                            <Button onClick={() => this.startEditing(extra)} className='viewButtons' style={{ backgroundColor: '#d4d4d4', color: 'black' }}>Edit</Button>
                                            <Button className='viewButtons' onClick={() => this.setState({ deleteId: extra.id, confirmOpen: true })}>
                                                Delete
                                            </Button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </ThemeProvider>
        );
    }
}

export default withStyles(useStyles)(Extras);
